import { pushToDataLayer } from './push-to-data-layer'

type DownloadDataLayerPlatform = 'windows' | 'mac'

function getDownloadFilename(downloadHref: string) {
  try {
    const url = new URL(downloadHref)
    const filename = url.pathname.split('/').pop()
    return filename || downloadHref
  } catch {
    return downloadHref
  }
}

export function pushClientDownloadEventToDataLayer(platform: DownloadDataLayerPlatform, downloadHref: string) {
  const filename = getDownloadFilename(downloadHref)
  const eventAction = platform === 'windows' ? 'Windows' : 'Mac OS'
  const eventLabel =
    platform === 'windows' ? `EVE client Windows download - ${filename}` : `EVE client Mac download - ${filename}`

  pushToDataLayer({
    eventCategory: 'EVE Client Download',
    eventAction,
    eventLabel,
  })
}
